// @ts-nocheck
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../../components/ant/DatePicker';
import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, OrgUnitSelect, Selects } from './../../../../components';
import Field from './../../../../components/card/Field';
import { formatDateTimeToISOString } from './../../../../lib/helpers';
const {
  FuelTypeSelect,
  MeasureTypeFuelPriceSelect,
  RateTypeSelect
} = Selects;
const SpoilerContent = styled.div.withConfig({
  displayName: "Filter__SpoilerContent",
  componentId: "sc-lp9f2s-0"
})(["padding:16px;"]);
export const ActFilter = ({
  filter,
  cleanFilter,
  applyFilter
}) => <SpoilerContent>
    <FilterContainer>
      <Filter cleanFilter={cleanFilter} applyFilter={applyFilter} initialValues={filter} additionalFilter>
        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter,
        showAdditional,
        handleAdditional
      }) => <>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect size="small" onChange={value => changeValue('nodeId', value)} value={values['nodeId']} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <FuelTypeSelect size="small" onChange={value => changeValue('fuelType', value)} value={values.fuelType} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RateTypeSelect size="small" onChange={value => changeValue('rateType', value)} value={values.rateType} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <MeasureTypeFuelPriceSelect size="small" onChange={value => changeValue('measureType', value)} value={values['measureType']} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <DatePicker size="small" placeholder="Дата начала" value={values.startDate ? moment(values.startDate) : undefined} format={'DD.MM.YYYY'} onChange={(value, dateString) => {
              changeValue('startDate', formatDateTimeToISOString(value, dateString));
            }} />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <DatePicker size="small" placeholder="Дата окончания" value={values.startDate ? moment(values.startDate) : undefined} format={'DD.MM.YYYY'} onChange={(value, dateString) => {
              changeValue('startDate', formatDateTimeToISOString(value, dateString));
            }} />
              </Field>
            </FilterItem>

            <FilterButtonsContainer applyFilter={applyFilter} cleanFilter={cleanFilter} handleAdditional={handleAdditional} showAdditional={showAdditional} />
          </>}
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
export default ActFilter;
